import Styled from 'styled-components';

import { media } from '../../../lib/StyledComponents';
import { HeaderInnerContainer } from '../HeaderInnerContainer';

const scrollableSubNavHeight: string = '2.75em;';

export const ScrollableSubNavInnerContainer = Styled(HeaderInnerContainer)`
  height: ${scrollableSubNavHeight};
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: -ms-autohiding-scrollbar;
`;

ScrollableSubNavInnerContainer.displayName = 'ScrollableSubNavInnerContainer';

export const ScrollableSubNavInnerContainerWithoutPadding =
  Styled(HeaderInnerContainer)`
    height: ${scrollableSubNavHeight};
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0;
    -ms-overflow-style: -ms-autohiding-scrollbar;

    ${media.small`
      padding: 0;
    `}

    ${media.medium`
      padding: 0;
    `}

    ${media.xlarge`
      padding: 0;
    `}
  `;

ScrollableSubNavInnerContainerWithoutPadding.displayName = 'ScrollableSubNavInnerContainerWithoutPadding';
